import React, {
  useState,
  useEffect,
  useRef,
  Fragment,
  useContext,
} from "react";

// Components
import PaymentModal from "./PaymentModal";
import AddFunds from "./AddFunds";
import Success from "./Success";

const PaymentModalParent = ({ purchaseType, nex }) => {
  const [multiStep, setMultiStep] = useState({
    step: 1,
  });

  const { step } = multiStep;
  const prevStep = () => {
    setMultiStep({ step: step - 1 });
  };
  const nextStep = () => {
    setMultiStep({ step: step + 1 });
  };
  switch (step) {
    case 1:
      return <PaymentModal purchaseType={purchaseType} nextStep={nextStep} />;
    case 2:
      return (
        <AddFunds
          prevStep={prevStep}
          nextStep={nextStep}
          purchaseType={purchaseType}
        />
      );
    default:
  }
  // <-----> <----->

  return <>{step}</>;
};
export default PaymentModalParent;
